import React from "react";
import { Dialog, DialogContent, DialogClose, DialogTitle, DialogDescription } from "@/shared/components/ui";
import { IconButton } from "@/shared/components/ui/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { ModalConfig } from "../contexts/ModalProvider";
import { cn } from "../utils";

interface ModalTemplateProps {
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
    config?: ModalConfig;
}

const ModalTemplate: React.FC<ModalTemplateProps> = ({ onClose, title, children, config }) => {
    const { hideCloseButton, contentWrapperClass, closeButtonClass } = config || {};

    function handleOverlayClick() {
        onClose();
    }

    function handleContentClick(event: React.MouseEvent) {
        event.stopPropagation();
    }

    return (
        <Dialog open={true} onOpenChange={onClose}>
            <DialogContent onEscapeKeyDown={handleOverlayClick} onClick={handleContentClick} className={cn(contentWrapperClass)}>
                {title && (
                    <VisuallyHidden asChild>
                        <DialogTitle>{title}</DialogTitle>
                    </VisuallyHidden>
                )}
                <VisuallyHidden asChild>
                    <DialogDescription />
                </VisuallyHidden>
                {!hideCloseButton && (
                    <DialogClose asChild className={closeButtonClass}>
                        <IconButton onClick={onClose}>
                            <FontAwesomeIcon icon={faXmark} className="size-5 text-content-primary" />
                        </IconButton>
                    </DialogClose>
                )}
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default ModalTemplate;
